import { createSlice } from '@reduxjs/toolkit';
import { submitCallbackRequest } from "../callbackRequest/actions/submitCallbackRequest";
var initialState = {
  isCheckboxChecked: false
};
export var checkboxAgreementSlice = createSlice({
  name: 'checkAddressPopup',
  initialState: initialState,
  reducers: {
    setIsCheckboxChecked: function setIsCheckboxChecked(state) {
      state.isCheckboxChecked = !state.isCheckboxChecked;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(submitCallbackRequest.fulfilled, function (state) {
      state.isCheckboxChecked = false;
    });
  }
});
var setIsCheckboxChecked = checkboxAgreementSlice.actions.setIsCheckboxChecked;
export { setIsCheckboxChecked };
export var checkboxAgreementReducer = checkboxAgreementSlice.reducer;